import React from 'react';
import { Keyboard } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogBody,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

type ShortcutRow = { keys: string; description: string };

const GLOBAL_SHORTCUTS: ShortcutRow[] = [
  { keys: '⌘ / Ctrl + K', description: 'Open command menu (go anywhere, continue last character or campaign)' },
  { keys: 'Shift + ?', description: 'Open this keyboard shortcuts list' },
  { keys: 'Esc', description: 'Close dialogs and menus' },
];

const COMPENDIUM_SHORTCUTS: ShortcutRow[] = [
  { keys: 'Esc', description: 'Clear search (when the compendium search field is focused)' },
];

interface KeyboardShortcutsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function KeyboardShortcutsDialog({ open, onOpenChange }: KeyboardShortcutsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-md:flex max-md:flex-col max-md:max-h-[100dvh]">
        <DialogHeader>
          <DialogTitle className="section-heading flex items-center gap-2">
            <Keyboard className="w-5 h-5 text-forest-green" aria-hidden />
            Keyboard shortcuts
          </DialogTitle>
        </DialogHeader>
        <DialogBody className="space-y-6 py-2">
          <section>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-text-muted mb-2">Everywhere</h3>
            <ul className="space-y-2 text-sm">
              {GLOBAL_SHORTCUTS.map((row) => (
                <li key={row.description} className="flex flex-col sm:flex-row sm:items-start sm:gap-4 gap-1">
                  <kbd className="shrink-0 font-mono text-xs px-2 py-1 rounded border border-border-default bg-bg-secondary whitespace-nowrap">
                    {row.keys}
                  </kbd>
                  <span className="text-text-primary">{row.description}</span>
                </li>
              ))}
            </ul>
          </section>
          <section>
            <h3 className="text-xs font-semibold uppercase tracking-wide text-text-muted mb-2">Compendium</h3>
            <ul className="space-y-2 text-sm">
              {COMPENDIUM_SHORTCUTS.map((row) => (
                <li key={row.description} className="flex flex-col sm:flex-row sm:items-start sm:gap-4 gap-1">
                  <kbd className="shrink-0 font-mono text-xs px-2 py-1 rounded border border-border-default bg-bg-secondary whitespace-nowrap">
                    {row.keys}
                  </kbd>
                  <span className="text-text-primary">{row.description}</span>
                </li>
              ))}
            </ul>
          </section>
          <Button type="button" variant="default" className="w-full" onClick={() => onOpenChange(false)}>
            Done
          </Button>
        </DialogBody>
      </DialogContent>
    </Dialog>
  );
}
